import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

export const entityContainerStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const entityBadgeStyle = css`
  padding: 8px 8px;
  gap: 4px;
  background-color: ${colors.SECONDARY_400};
  border-radius: 8px;
  color: ${colors.NEUTRAL_0};
  display: inline-flex;
  align-items: center;
  cursor: default;
`

export const entityImageStyle = css`
  border-radius: 4px;
  border: 2px solid ${colors.WHITE};
  background: white;
  object-fit: contain;
`
